
import { BusinessTripRatesContent } from './BusinessTripRatesContent'
import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary'

export const BusinessTripRatesPage = withDefaultErrorBoundary(BusinessTripRatesContent)
